/**
 * Desktop-local mirror of the shared chapter comment contract.
 *
 * Keep in sync with the repository-root src/shared/chapterCommentTypes.ts. Electron's
 * compiler cannot import source outside desktop-v2's rootDir.
 */
export const CHAPTER_TEXT_COMMENT_TYPES = [
  "note",
  "question",
  "suggestion",
  "issue",
  "praise",
] as const;
export type ChapterTextCommentType = (typeof CHAPTER_TEXT_COMMENT_TYPES)[number];

export const CHAPTER_COMMENT_TYPE_SLUGS = [
  "suggestion",
  "issue",
  "praise",
  "question",
  "note",
  "highlight",
] as const;

export type ChapterCommentTypeSlug = (typeof CHAPTER_COMMENT_TYPE_SLUGS)[number];

export const CHAPTER_COMMENT_TYPE_SET = new Set<string>(CHAPTER_COMMENT_TYPE_SLUGS);
export const CHAPTER_DOC_MARK_COMMENT_TYPES = new Set<string>(CHAPTER_COMMENT_TYPE_SLUGS);

export const CHAPTER_COMMENT_TYPE_LABELS: Record<string, string> = {
  note: "Note",
  question: "Question",
  suggestion: "Suggestion",
  issue: "Issue",
  praise: "Praise",
  highlight: "Highlight",
};

export function formatChapterCommentTypeLabel(type: string | undefined): string {
  if (!type) return "Note";
  const mapped = CHAPTER_COMMENT_TYPE_LABELS[type];
  if (mapped) return mapped;
  return type.replace(/_/g, " ").replace(/\b\w/g, (character) => character.toUpperCase());
}

export function normalizeChapterCommentType(value: string | undefined): string {
  const type = (value ?? "").trim().toLowerCase();
  return CHAPTER_COMMENT_TYPE_SET.has(type) ? type : "note";
}

export function chapterCommentTypeClassSlug(type: string | undefined): string {
  return normalizeChapterCommentType(type).replace(/[^a-z0-9-]/g, "") || "note";
}
